import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/suppliers/')({
  component: SuppliersPage,
})

function SuppliersPage(): JSX.Element {
  return <div>Proveedores — placeholder</div>
}
